export default {"src":"/_next/static/media/how-to-use-it.mono.2f9d6681.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};